/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import api from './services/api'
import router from './router/router'
import store from './store/store'
import Field from '@/components/Field.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCircle, faCheckCircle, faPencil, faBars } from '@fortawesome/pro-regular-svg-icons'
import { faCaretDown, faCaretLeft, faGlobe, faEnvelope, faPhone, faTimes, faUser, faUserFriends, faRocket, faSearch, faMinusCircle, faLock } from '@fortawesome/free-solid-svg-icons'
import { faThumbsUp as fadThumbsUp, faThumbsDown as fadThumbsDown, faUserCircle as fadUserCircle, faEnvelope as fadEnvelope } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import './assets/scss/index.scss'

if (process.env.NODE_ENV != 'development') {
  window.onbeforeunload = function () {
    //if (valueChangeObserver() > valueChangeCheckpoint)
    //  return "You have unsaved changes.  Are you sure?";
    //if (self.submitting)
    //  return "Your loan application is in the process of being submitted.  Please press cancel to stay on the page.";
    if (store.getters.getSubmitResult === null)
      return "Are you sure you want to close your loan application?  You will lose all your entered data if you leave without submitting the application."
  }
}

library.add(
  faBars,
  faCaretDown,
  faCaretLeft,
  faCircle,
  faCheckCircle,
  faEnvelope,
  fadEnvelope,
  faPencil,
  faTimes,
  faPhone,
  faGlobe,
  faUser,
  faUserFriends,
  faRocket,
  fadThumbsUp,
  fadThumbsDown,
  faSearch,
  faMinusCircle,
  faLock,
  fadUserCircle
)

Vue.component('icon', FontAwesomeIcon)

Vue.component('Field', Field)

Vue.prototype.$http = api

Vue.config.productionTip = false

if (process.env.NODE_ENV == 'development') {
  window.store = store
}

new Vue({
  router,
  store,
  data: () => {
    return {
      isReady: false
    }
  },
  render: h => h(App)
}).$mount('#app')
